import { Link } from '@lmig/lmds-react-link';
import { Heading } from '@lmig/lmds-react-typography';
import '../PageContent/Shared/Tiles/Tile.scss';
import './MyFavoritesTile.scss';
import { useContext, useEffect, useState } from 'react';
import { ISliderContext } from 'Feature/Slider/Models/Panels';
import { SliderContext } from 'Feature/Slider/SliderContext';
import { getPanelLinks } from './FavoritesHelper';
import FavoritesList from 'Feature/Favorites/FavoritesList';

const MyFavoritesTile = () => {
  const sliderContext = useContext<ISliderContext>(SliderContext);
  const [sections, setSections] = useState<IReactNavSection[]>([]);

  useEffect(() => {
    if (sliderContext.panels) {
      let linkSections: IReactNavSection[] = getPanelLinks(sliderContext.panels);
      if (linkSections.length > 0) setSections(linkSections);
    }
  }, [sliderContext.panels]);

  return (
    <div className="my-favorites-tile tile">
      <div className="tile-header">
        <Heading type="h4-light">My favorites</Heading>
        <Link variant="standalone" href="/manage-my-favorites">
          Manage all favorites
        </Link>
      </div>
      <FavoritesList sections={sections}></FavoritesList>
    </div>
  );
};

export default MyFavoritesTile;
